import { render, staticRenderFns } from "./editable-table.vue?vue&type=template&id=51592fb3&scoped=true"
import script from "./editable-table.vue?vue&type=script&lang=js"
export * from "./editable-table.vue?vue&type=script&lang=js"
import style0 from "./editable-table.vue?vue&type=style&index=0&id=51592fb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51592fb3",
  null
  
)

export default component.exports